<template>
    <div class="sidebar">
        <div class="sidebar-nav-box">
            <div class="sidebar-nav">
                <ul class="nav">
                    <li class="item item-bold item-click-bold item-click-active">
                        <a :href="'/stockIndex/stockIndex.html?stockCode='+this.code" class="">
                            <em class="active-img"></em>
                            <span :title=title :code=code>{{ title }}</span>
                        </a>
                    </li>
                    <li class="item item-bold">
                        <span>公司概况</span>
                    </li>
                    <li class="item item-click">
                        <a href="/companyGeneral/introduce.html" class="plink">
                            <em class="active-img"></em>
                            <span>公司简介</span>
                        </a>
                    </li>
                    <li class="item item-click" >
                        <a href="/companyGeneral/senior.html" class="plink">
                            <em class="active-img"></em>
                            <span>公司高管</span>
                        </a>
                    </li>
                    <li class="item item-bold">
                        <span>股本股东</span>
                    </li>
                    <li class="item item-click">
                        <a href="/equityShareholders/equityStructures.html" class="plink">
                            <em class="active-img"></em>
                            <span>股本结构</span>
                        </a>
                    </li>
                    <li class="item item-click">
                        <a href="/equityShareholders/mainShareholder.html" class="plink">
                            <em class="active-img"></em>
                            <span>主要股东</span>
                        </a>
                    </li>
                    <li class="item item-click">
                        <a href="/equityShareholders/circulateShareholder.html" class="plink">
                            <em class="active-img"></em>
                            <span>流通股东</span>
                        </a>
                    </li>
                    <li class="item item-click">
                        <a href="/equityShareholders/shareholderNum.html" class="plink">
                            <em class="active-img"></em>
                            <span>股东户数</span>
                        </a>
                    </li>
                    <li class="item item-bold">
                        <span>财务数据</span>
                    </li>
                    <li class="item item-click">
                        <a href="/financialData/mainFinancialIndicator.html" class="plink">
                            <em class="active-img"></em>
                            <span>主要财务指标</span>
                        </a>
                    </li>
                    <li class="item item-click">
                        <a href="/financialData/costSales.html" class="plink">
                            <em class="active-img"></em>
                            <span>利润表</span>
                        </a>
                    </li>
                    <li class="item item-click">
                        <a href="/financialData/balanceSheet.html" class="plink">
                            <em class="active-img"></em>
                            <span>资产负债表</span>
                        </a>
                    </li>
                    <li class="item item-click">
                        <a href="/financialData/crashFlows.html" class="plink">
                            <em class="active-img"></em>
                            <span>现金流量表</span>
                        </a>
                    </li>
                    <li class="item item-bold">
                        <span>新闻公告</span>
                    </li>
                    <li class="item item-click">
                        <a href="/news/noticeList.html" class="plink">
                            <em class="active-img"></em>
                            <span>最新公告</span>
                        </a>
                    </li>
                    <li class="item item-click">
                        <a href="/news/newsList.html" class="plink">
                            <em class="active-img"></em>
                            <span>相关新闻</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'sidebar',
        props: {
            title: '',
            code: {
                type: String
            }
        },
        data() {
            return {
            }
        },
        created:function(){
            /*let getStockCode=window.sessionStorage.getItem('stockCode');
            if (typeof getStockCode=="string") {
                this.stockCode=window.sessionStorage.getItem('stockCode')!='null'? window.sessionStorage.getItem('stockCode'):600000;
            } else{
                this.stockCode=window.sessionStorage.getItem('stockCode')!=null? window.sessionStorage.getItem('stockCode'):600000;
            }*/
        },
        mounted() {
            let pathname = window.location.pathname
            let idx = 999
            if(pathname.indexOf('introduce') != -1){
                idx = 0;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('senior') != -1){
                idx = 1;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('equityStructures') != -1){
                idx = 2;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('mainShareholder') != -1){
                idx = 3;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('circulateShareholder') != -1){
                idx = 4;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('shareholderNum') != -1){
                idx = 5;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('mainFinancialIndicator') != -1){
                idx = 6;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('costSales') != -1){
                idx = 7;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('balanceSheet') != -1){
                idx = 8;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('crashFlows') != -1){
                idx = 9;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('noticeList') != -1 || pathname.indexOf('noticeDetail') != -1){
                idx = 10;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('newsList') != -1 || pathname.indexOf('newsDetail') != -1){
                idx = 11;
                this.itemClickActive(idx);
            }else if(pathname.indexOf('') != -1){
                this.removeClickActive();

            }
        },
        methods: {
            itemClickActive: function (idx) {
                $('.nav').find('.item-click-bold').removeClass('item-click-active');
                $('.nav').find('.item-click').removeClass('item-click-active');
                $('.nav').find('.item-click').eq(idx).addClass('item-click-active');
            },
            removeClickActive: function () {
                $('.nav').find('.item-click').removeClass('item-click-active');
                $('.nav').find('.item-click-bold').addClass('item-click-active');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~scss/mixin";
    .sidebar{
        height: 830px;
        .sidebar-nav-box{
            .sidebar-nav{
                .nav{
                    position: absolute;
                    padding-top: 15px;
                    .item{
                        width: 180px;
                        height: 40px;
                        .plink{
                            display: block;
                            height: 40px;
                            margin-left: 40px;
                        }
                    }
                    .item-bold{
                        position: relative;
                        .icon{
                            position: absolute;
                            top: 3px;
                            left: 30px;
                        }
                        span{
                            line-height: 40px;
                            margin-left: 40px;
                            font-weight: bold;
                        }
                        em{
                            width: 0;
                            height: 0;
                        }
                    }
                    .item-click{
                        position: relative;
                        cursor: pointer;
                        span{
                            line-height: 40px;
                            font-size: 16px;
                        }
                        em{
                            width: 0;
                            height: 0;
                        }
                    }
                    .item-click:hover{
                        background: url(~images/item-bg.jpg) no-repeat center left;
                        span{
                        	color: #ff3c42;
                        }
                    }
                    .item-click-active{
                        background: url(~images/item-bg.jpg) no-repeat center left;
                        span{
                        	color: #ff3c42;
                        }
                        em{
                            position: absolute;
                            top: 15px;
                            left: 21px;
                            display: inline-block;
                            width: 10px;
                            height: 9px;
                            background: url(~images/red-arrow.png) no-repeat center left;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue